import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { setGoHome, setLoader, setOpenExternalLinkInSameTab } from "../../action/homeAction";
import { CMSPath, ENABLE_HOTEL_SELECTOR_QUICK_LINKS } from "../../../config/constant";
import { getHotelList, getHotelListUpdatingProps } from "../../../action/hotelSelector";
import { setFailScreen, setHotelSelectionAfterLoginState } from "../../../action/action";
import { sendAnalytics } from "../../../action/homeAction";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import externalLinkSvg from "./assets/link-external.svg";
import { clearDoorKey, wipeGuestData } from "../../../JS/wipeGuestData";
import HotelChangeConfirmPopup from "./HotelChangeConfirmPopup";
import { handleLocationSelect } from "./hotelSelector";
import PromoWidget from "../home/promoWidget";
import { scrollToTop } from "../../../JS/scrollToTop";
import MiniLoader from "../../UI/MiniLoader";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { inAppBrowser } from "../../JS/inAppBrowser";
import { getCdnUrl } from "../../../config/config";


const HotelSelector = (props) => {

    const { t } = props;

    const [fetchHotelListAttempted, setFetchHotelListAttempted] = React.useState(false);

    const [masterConnector, setMastorConnector] = React.useState({});
    const [hotelRegionData, setHotelRegionData] = React.useState([]);

    const master_hotel_code = process.env.REACT_APP_CLIENT_CONFIG.replace("GJ_", "").toUpperCase();
    const current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();

    let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })

    const goHome = () => {
        props.setGoHome(true);
    }

    const handleOnSelectHotel = (hotelData) => {
        handleLocationSelect(props, hotelData, false, (status) => {
            if (!status) {
                goHome();
                // props.closeOrderPopUp(true, t("hotelSelector.already_selected_location"), "", false);
            }
        })
    }

    const handleSuccessResponse = (data) => {
        setHotelRegionData(data);

        if (data && data.length > 0) {
            for (const hotelRegion of data) {
                if (hotelRegion.hotelList && hotelRegion.hotelList.length > 0) {
                    for (const hotelData of hotelRegion.hotelList) {
                        if (hotelData.hotelPropertyKey == master_hotel_code) {
                            setMastorConnector(hotelData);
                            return;
                        }
                    }
                }
            }
        }

    }

    React.useEffect(() => {
        handleSuccessResponse(props.location_data.payload);

        if(props.location_data.status == "FAILED" && !fetchHotelListAttempted){
            props.getHotelListUpdatingProps();
            setFetchHotelListAttempted(true)
        }

    }, [props.location_data, fetchHotelListAttempted])

    React.useEffect(() => {
        scrollToTop();
    }, [])

    return (
        <>
            {props.currentWidgetObj.widgetType &&
                <header className="inner-pages w-footer subpages">
                  { !process.env.REACT_APP_NEWER_DESIGN=="true" &&  <a className="button-back" onClick={() => goHome()}></a>}
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${props.logo}`} />
                        </div>
                        {/* <p className="bold" style={{ color: "inherit" }}>{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                    </div>

                </header>}

            <section className="widgets padding-0 margin-0 container-bg loc-selector">

                <div class="widget-header widget-header-checkin-inner">
                    {props.currentWidgetObj.widgetHeaderImageUrl ?
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                        </div>
                        :
                        props.promoWidgets && props.promoWidgets.length > 0 ?
                            <PromoWidget promoWidgets={props.promoWidgets} />
                            :
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${props.bgImage}`} alt={props.currentWidgetObj.displayName} />
                            </div>
                    }

                    <div class="widget-header-title">
                        {t('hotelSelector.select_location_heading')}
                        <p>{t('hotelSelector.select_location_subheading')}</p>
                    </div>
                </div>

                <div>
                     <div class="widget-header-title2">
                         <div class="heading" dangerouslySetInnerHTML={ {__html: t('hotelSelector.select_location_heading2')}}></div> 
                         <div class="subheading" >{t('hotelSelector.select_location_subheading2')}</div>
                    </div>
                </div>

                <div className="widgets">

                    {
                        props.location_data.status == "PENDING" ?
                            <MiniLoader />
                            : props.location_data.status == "FAILED" ?
                                <div className="hotel-selector-error" >
                                    <p>{t('hotelSelector.something_went_wrong')}</p>
                                    <button onClick={()=>{setFetchHotelListAttempted(false);}}>{t('hotelSelector.retry')}</button>
                                </div>
                                :
                                <>
                                    {Object.keys(masterConnector).length > 0 && <div onClick={() => handleOnSelectHotel(masterConnector)} class={`tile-selection tile-container master-connector app-link ${current_hotel_code == masterConnector.hotelPropertyKey && "selected-hotel"}`}>
                                        <div class="tile-selection-img">
                                            {masterConnector.hotelBannerImageUrl ?
                                                <img src={getCdnUrl(CMSPath, masterConnector.hotelBannerImageUrl)}></img> :
                                                ""
                                            }
                                        </div>
                                        <div class="tile-selection-text">
                                            <div class="tile-selection-heading">{masterConnector.hotelName}</div>
                                            <div class="tile-selection-desc">{masterConnector.hotelAddress}</div>
                                            <div class="tile-selection-desc">{masterConnector.hotelAboutInfo}</div>
                                        </div>
                                        <img src={externalLinkSvg} />
                                    </div>}

                                    {
                                        hotelRegionData.length > 0 && hotelRegionData.map((hotelRegion, index) => {
                                            return (
                                                <div key={index}>
                                                    <h3>{hotelRegion.region}</h3>

                                                    {hotelRegion.hotelList.map((hotelData) => {
                                                        return (
                                                            hotelData.hotelPropertyKey != master_hotel_code && <div onClick={() => handleOnSelectHotel(hotelData)} class={`tile-selection tile-container ${hotelData.isDisabled? "disableHotel":""} ${hotelData.hotelIsAppSupported ? "app-link" : "external-link"} ${current_hotel_code == hotelData.hotelPropertyKey && "selected-hotel"}`}>
                                                                <div class="tile-selection-img">
                                                                    {hotelData.hotelBannerImageUrl ?
                                                                        <img src={getCdnUrl(CMSPath, hotelData.hotelBannerImageUrl)}></img> :
                                                                        ""
                                                                    }
                                                                </div>
                                                                <div class="tile-selection-text">
                                                                    <div class="tile-selection-heading">{hotelData.hotelName}</div>
                                                                    <div class="tile-selection-desc">{hotelData.hotelAddress}</div>
                                                                    <div class="tile-selection-desc">{hotelData.hotelAboutInfo}</div>
                                                                </div>
                                                                <img src={externalLinkSvg} />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            )
                                        })
                                    }
                                </>
                    }

                    {
                        <>
                            { ENABLE_HOTEL_SELECTOR_QUICK_LINKS && <>
                            <div className="quick-links">
                                <p class="contact us" onClick={() => { { inAppBrowser(t("hotelSelector.support.heading1_link"), props, false, { displayName: "contact us", dontSetCurrentWidget: true }) } }}>{t(`hotelSelector.support.heading1`)}</p>
                                <p class="tnc" onClick={() => { { inAppBrowser(t("hotelSelector.support.heading2_link"), props, false, { displayName: "tnc", dontSetCurrentWidget: true }) } }}>{t(`hotelSelector.support.heading2`)}</p>
                                <p class="pnp" onClick={() => { { inAppBrowser(t("hotelSelector.support.heading3_link"), props, false, { displayName: "pnp", dontSetCurrentWidget: true }) } }}>{t(`hotelSelector.support.heading3`)}</p>
                            </div>
                            <div className="quick-links buildNo">
                                <p class="contact us" >{`${props.installedAppVersion} (${props.installedAppBuildNo})`}</p>
                            </div>
                           
                            </>}
                        </>
                    }

                </div>
            </section>
        </>
    )
}

const getWidgetSelector = (state) => {

    var widgets = [];

    state.store.home.currentDuration.bigWidgets.map((obj) => {
        if (state.store2.currentHomePage.tabName) {
            if (obj.uniqueKey === state.store2.currentHomePage.uniqueKey
                || obj.uniqueKey === state.store2.currentHomePage.tabName.replace(/ /g, '').toLowerCase()) {
                widgets = obj.widgets
            }
        }
    })
    console.log('getWidgetSs', widgets)
    return widgets
};

const mapStateToProps = state => {
    return {
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        menuColor: state.store.home.MenuColor,
        promoWidgets: state.store.home.currentDuration.bigWidgets ? getWidgetSelector(state) : [],
        bgImage: state.store.home.currentDuration.launcherBgImageUrl,
        location_data: state.store2.location_data,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
            externalSignIn: state.store2.externalSignIn,
    }
}

export default connect(mapStateToProps, { setGoHome, setOpenExternalLinkInSameTab, closeOrderPopUp, setLoader, setFailScreen, setHotelSelectionAfterLoginState, sendAnalytics, getHotelListUpdatingProps })(withTranslation('translations')(HotelSelector));